import React from "react";
import { EditUserPage } from "../users/edit-page";

export default props => (
  <EditUserPage
    backTo={`/partner/edit/${props.match.params.partnerId}`}
    username={props.match.params.id}
  />
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/users-partners/Edit.js